import type { paths } from "../api/generated/api-types";

// Single source of truth for permission strings: derived from the generated
// OpenAPI types (backend `Permission` enum surfaced on the /me response), per
// frontend.api-types-as-contract. Frontend gating uses this union (BR-AC-04);
// the required permission of every gated control is mapped in
// docs/screens/PermissionGating.md. Other modules import this alias rather
// than re-deriving the permission union from `paths[...]` locally.
export type Permission =
  paths["/me"]["get"]["responses"]["200"]["content"]["application/json"]["role"]["permissions"][number];

export function hasPermission(permissions: Permission[] | undefined, permission: Permission): boolean {
  const granted = permissions !== undefined && permissions.includes(permission);
  return granted;
}
